import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Font = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M13.937 4.649A1.002 1.002 0 0 0 13 4h-2c-.417 0-.79.259-.937.649L4.307 20h2.137l1.875-5h7.363l1.875 5h2.137L13.937 4.649zM9.068 13l2.625-7h.614l2.625 7H9.068z", key: "k0" })));
});
Font.displayName = 'Font';
export var FontDimensions = { height: 24, width: 24 };
